import { COLORS } from 'constants/colors'
import styled from 'styled-components'

export const List = styled.ul`
  overflow: auto;
  height: 330px;
`

export const Item = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 25px 12px 0px;

  &:not(:last-of-type) {
    border-bottom: 1px solid #ebebeb;
  }
`

export const Title = styled.p`
  color: ${COLORS.text.default};
  font-size: 14px;
  line-height: 1.3;
`

export const ShowMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;

  cursor: pointer;
`

export const ShowMoreText = styled.p`
  margin-right: 4px;

  font-size: 14px;
  line-height: 1.4;
  font-weight: 500;
  color: ${COLORS.text.default};
`
